export enum TransactionStates {
  INITIATED = 'INITIATED',
  PENDING = 'PENDING',
  SUCCESSFUL = 'SUCCESSFUL',
  CANCELED = 'CANCELED',
  DECLINED = 'DECLINED',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  APPROVED = 'APPROVED',
  AUTHORIZED = 'AUTHORIZED',
}
